import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { ExpiryWarningService } from "./expiry-warning.service";

@Injectable()
export class ExpiryWarningResolver implements Resolve<Promise<any>> {
  constructor(private expiryWarningService: ExpiryWarningService) {}

  async resolve(route: ActivatedRouteSnapshot) {
    try {
      const outletResponse = await this.expiryWarningService.getExpiryDetailAPI();

      let response = outletResponse;
      return response;
    } catch (err) {
      console.error("Failed to retrieve expiry details", err);
      return null;
    }
  }
}
